import { render } from "./TenantConfigurationManagement.vue?vue&type=template&id=e10c099e&scoped=true"
import script from "./TenantConfigurationManagement.vue?vue&type=script&lang=js"
export * from "./TenantConfigurationManagement.vue?vue&type=script&lang=js"

import "./TenantConfigurationManagement.vue?vue&type=style&index=0&id=e10c099e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e10c099e"]])

export default __exports__